import { useEffect } from 'react';

/**
 * Redirects /privacy to the static HTML privacy policy so crawlers and users
 * without JS still hit the static page when given /privacy.html.
 */
function PrivacyRedirect() {
  useEffect(() => {
    window.location.replace('/privacy.html');
  }, []);
  return null;
}

export default PrivacyRedirect;
